<template>
    <v-row>
        <v-col>
            <work-space-notify 
                v-for="config in list_configs" 
                :key="config.id"
                :init_config="config" 
                :timezones="timezones"
                @update="onUpdate"
                @save="onSave"
                @fetching="onFetching">
            </work-space-notify>
        </v-col>
        <v-overlay :value="isFetching">
        <v-progress-circular
            indeterminate
            size="64"
        ></v-progress-circular>
        </v-overlay>
    </v-row>
</template>
<script>

import { mapActions, mapGetters } from 'vuex'
import * as api from '@/api/workspace';
import WorkSpaceNotify from "@/app/components/workspace/notifications/WorkSpaceNotify";
// import _ from 'lodash';

export default {
    name: 'WorkSpaceNotifyConfig',
    components:{
        WorkSpaceNotify
    },
    props:{
        notify_type: { 
            type: String,
            default: null,
            required: false
        },
        default_configs: { 
            type: Array,
            default: () => [],
            required: false
        },
    },
    data () {
        return {
            configs: [],
            timezones: [],
            isFetching: false
        }
    },
    created(){
        this.load();
    },
    watch:{
        ID_WORK_SPACE: function(newV, oldV){
            if(newV != oldV){
                this.load();
            }
        }
    },
    methods: {
        async load(){
            this.isFetching = true;
            try{
                let response = await api.notifyConfigIndex(this.ID_WORK_SPACE, {notify_type: this.notify_type});
                this.setConfigs(response.data.configs);
                this.setTimezones(response.data.timezones);
            }catch(e){
                console.log(e);
            }finally{
                this.isFetching = false;
            }
        },
        onFetching(val){
            this.isFetching = val;
        },
        onUpdate(config){
            let ind = this.configs.findIndex(conf => config.id === conf.id);
            if(ind !== -1){
               this.configs.splice(ind, 1, config);
            }
        },
        onSave(config){
            this.onFetching(false);
            this.configs.push(config);
        },
        setConfigs(configs){
            this.configs.splice(0, this.configs.length, ...configs);
        },
        setTimezones(timezones){
            this.timezones.splice(0, this.timezones.length, ...timezones);
        },
        ...mapActions('notifications', ['SHOW_ERROR', 'SHOW_SUCCESS']),
    },
    computed:{
        list_configs(){
            let types = this.configs.map(v => v.notify_type);
            let result = [...this.configs];
            for(let defaultConfig of this.default_configs){
                if( ! types.includes(defaultConfig.notify_type) ){
                    result.push(defaultConfig);
                }
            }
            return result;
        },
        ...mapGetters('workspace', ['ID_WORK_SPACE', 'IS_LOAD_WORK_SPACE']),
    }
}
</script>